<template>
  <div class="d-flex">
    <p v-if="state == 'dialing'" class="d-flex align-items-center mb-0 mt-2">
      {{ $t('tasks.campaign.state.dialing') }}
    </p>
    <p v-if="state == 'conversation'" class="d-flex align-items-center mb-0 mt-2">
      {{ time }}
    </p>
    <icon
      v-if="state != 'conversation' && state != 'dialing' "
      type="ios-call"
      class="digit"
      color="green"
      :size="size"
      @click="call(number)"
    />
    <icon
      v-else
      type="ios-call"
      class="digit"
      color="red"
      :size="size"
      @click="hangup"
    />
  </div>
</template>

<script>
  import { ASTERISK_INSTANSE } from '@shared/helpers/env';
  import { SipPhone } from '@app/plugins/jssip';
  import { IntegrateModalService } from '@administration/modals/IntegrateModalService';
  import { TasksService } from '@tasks/services/TasksService';
  import { mapGetters } from 'vuex';
  import moment from 'moment-es6';
  export default {
    props: {
      size: {
        type: Number,
        default: 40
      },
      number: {
        type: String,
        required: true
      },
      status: {
        type: String,
        default: ''
      },
      task_id: {
        type: [Number, String],
        default: ''
      },
      user_id: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        digits: [
          {
            number: 1,
            sub: ''
          },
          {
            number: 2,
            sub: 'ABC'
          },
          {
            number: 3,
            sub: 'DEF'
          },
          {
            number: 4,
            sub: 'GHI'
          },
          {
            number: 5,
            sub: 'JKL'
          },
          {
            number: 6,
            sub: 'MNO'
          },
          {
            number: 7,
            sub: 'PQRS'
          },
          {
            number: 8,
            sub: 'TUV'
          },
          {
            number: 9,
            sub: 'WXYZ'
          },
          {
            number: '*',
            sub: ''
          },
          {
            number: 0,
            sub: ''
          },
          {
            number: '#',
            sub: ''
          }
        ],
        phone: null,
        server: ASTERISK_INSTANSE,
        call_start: null,
        time: null,
        interval: null
      };
    },
    computed: {
      ...mapGetters('core/auth', ['user', 'integrate']),
      state() {
        if (this.phone) return this.phone.state;
        return null;
      }
    },
    watch: {
      status: {
        handler: function (val) {
          if (val == 'hangup' && this.state != 'ready') {
            this.hangup();
          }
        },
        deep: true,
        immediate: true
      },
      state: {
        handler: function (val) {
          if (val == 'conversation') {
            this.call_start = Date.now();
            this.timer();
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      let login = this.user.sip_login;
      let pass = this.user.sip_password;
      // let login = 'crm_user_191_cjfO8lYp'
      // let pass = 'C9GDWpJfPteZ'
      this.phone = new SipPhone();
      this.phone.createDOM();
      this.phone.connect(this.server, login, pass);
    },
    beforeDestroy() {
      this.hangup();
    },
    methods: {
      timer() {
        let time;
        this.interval = setInterval(() => {
          time = Date.now() - this.call_start;
          this.time = moment(time).format('mm:ss');
        }, 1000);
      },
      add_number(number) {
        this.number = this.number + number;
      },
      remove_number() {
        this.number = this.number.slice(0, -1);
      },
      call(number) {
        // TODO сделать обработку запроса
        TasksService.bindManualTask(this.user_id, this.task_id)
          .then(() => console.log('binding success'))
          .catch(() => console.log('binding unsuccess'));
        this.integrate ? this.phone.call(number) : IntegrateModalService.create();
      },
      hangup() {
        this.phone.hangup();
        this.time = null;
        clearInterval(this.interval);
      }
    }
  };
</script>

<style lang="scss">
  .tab-row {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
    font-family: 'Exo';
  }

  .digit,
  .dig {
    float: left;
    width: 85px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .sub {
    font-size: 0.8rem;
    color: grey;
  }

  .tab-container {
    background-color: white;
    position: relative;
    right: 0;
    width: 320px;
    padding: 20px;
    margin: 0px auto;
    height: 420px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  #output {
    font-family: 'Exo';
    font-size: 2rem;
    height: 60px;
    font-weight: bold;
    color: #1976d2;
  }

  #call {
    display: inline-block;
    background-color: #66bb6a;
    padding: 4px 30px;
    margin: 10px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }

  .botrow {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
    font-family: 'Exo';
  }

  .digit:active,
  .dig:active {
    background-color: #e6e6e6;
  }

  #call:hover {
    background-color: #81c784;
  }

  .dig {
    float: left;
    padding: 10px 20px;
    margin: 10px;
    width: 30px;
    cursor: pointer;
  }
  .ivu-tabs.sip {
    position: absolute;
    right: 0;
    top: 30px;
    width: 320px;
    .ivu-tabs-bar {
      margin-bottom: 0;
    }
  }
  .font-size-22 {
    font-size: 22px;
  }
</style>
